import React, { FC, useState, useCallback, memo } from 'react';

import { Button } from 'antd';

import { useActions } from '../../../hooks/useActions';
import { useTypedSelector } from '../../../hooks/useTypedSelector';

interface MetricsSelectModalProps {
    /** dataKey выбранной метрики */
    dataKey: string;
    /** Callback для закрытия модального окна */
    setVisible: (visible: boolean) => void;
}

interface Metric {
    dataKey: string;
    name: string;
    label?: string;
}

/**
 * Модальное окно выбора метрики для осей Bubble Chart
 * Используется в отчётах и дашбордах
 */
const MetricsSelectModal: FC<MetricsSelectModalProps> = ({ dataKey, setVisible }) => {
    const { metrics, metricsChecked } = useTypedSelector((state) => state.table);
    const { setMetricsChecked, setMetaChartFetching } = useActions();

    const selectMetric = useCallback((index: number) => {
        const metric = (metrics as Metric[]).find((item) => item?.dataKey === dataKey);

        if (metric) {
            const _metrics = [...metricsChecked];
            _metrics[index] = { name: metric.dataKey, label: metric.name };

            setMetricsChecked({ data: _metrics });
            setMetaChartFetching({ value: true });
            setVisible(false);
        }
    }, [metrics, metricsChecked, dataKey, setMetricsChecked, setMetaChartFetching, setVisible]);

    return (
        <div className="metric-select-modal-wrapper">
            <Button type="text" onClick={() => selectMetric(0)}>
                Ось X
            </Button>

            <Button type="text" onClick={() => selectMetric(1)}>
                Ось Y
            </Button>

            <Button type="text" onClick={() => selectMetric(2)}>
                Диаметр
            </Button>
        </div>
    );
};

export default memo(MetricsSelectModal);
